// src/msalConfig.js

import { PublicClientApplication } from "@azure/msal-browser";

// --- IMPORTANT: Use the correct Client ID from your App Registration ---
// The ID in the screenshot of your App Registration is: e7c52e75-d663-4d74-bd06-a1d8b71dbfa1a
// The ID in your code is different. Use the one from the Azure portal.
const clientId = "e7c52e75-d663-4d74-bd06-a1d8b71dbfa1a"; 

// --- Your Directory (Tenant) ID from the Azure portal ---
const tenantId = "2ce951cb-4a50-403e-b230-568f8cb3b9d5"; 

// --- The API scope you defined in the "Expose an API" section ---
// Replace this with your exact Application ID URI and scope name
const apiScope = `api://${clientId}/access_as_user`;

// Configuration object for MSAL
export const msalConfig = {
    auth: {
        clientId: clientId, 
        authority: `https://login.microsoftonline.com/${tenantId}`,
        // This must match the production URL of your deployed application.
        redirectUri: "https://www.edgeneonline.com", 
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    }
};

// Request object for login. This will be used to get an access token.
export const loginRequest = {
    // We now request the custom API scope, in addition to the standard User.Read for user info.
    scopes: ["User.Read", apiScope],
};

// Create the MSAL PublicClientApplication instance
export const msalInstance = new PublicClientApplication(msalConfig);